import { AuthProvider } from 'auth/AuthContext';
import ProviderWrapper from 'components/ProviderWrapper';
import React, { Component } from 'react';
import Main from 'routes/Main';
import AppBootstrap from './AppBootstrap';
import './components/image/imageStyles.css';

class App extends Component {
  render() {
    return (
        <AuthProvider>
          <AppBootstrap>
            <ProviderWrapper>
              <Main/>
            </ProviderWrapper>
          </AppBootstrap>
        </AuthProvider>
    );
  }
}

export default App;
